var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"blockUI blockOverlay"}),_c('div',{staticClass:"blockUI blockMsg blockElement",style:(`${
      _vm.hideText
        ? 'width: 100%; height: 100%;display: flex; align-items: center;left: 0'
        : ''
    }`)},[(!_vm.hideText)?_c('div',{staticClass:"blockui"},[_c('span',[_vm._v("Please wait...")]),_vm._m(0)]):_c('div',{staticStyle:{"width":"100%","height":"100%","display":"flex","align-items":"center","justify-content":"center"}},[_c('div',{staticClass:"kt-spinner kt-spinner--v2 kt-spinner--success"})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',{staticClass:"kt-spinner kt-spinner--v2 kt-spinner--success"})])
}]

export { render, staticRenderFns }